import { createFileRoute, redirect } from '@tanstack/react-router'

import i18n from '@/i18n'
import {
  SchoolBreaksView,
  SchoolSettingsView,
  schoolBreaksFilterSchema
} from '@/modules/schoolSettings'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { isFeatureFlagEnabled } from '@/utils/is-feature-flag-enabled'

export const Route = createFileRoute('/_auth/school-settings/breaks/')({
  validateSearch: schoolBreaksFilterSchema,
  component: () => (
    <SchoolSettingsView>
      <SchoolBreaksView />
    </SchoolSettingsView>
  ),
  beforeLoad: async () => {
    if (!isFeatureFlagEnabled('IS_SCHOOL_BREAKS_MODULE_ENABLED'))
      throw redirect({ replace: true, to: '/' })
  },
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.school-settings', { ns: 'schoolSettings' }),
      i18n.t('title.school-breaks', { ns: 'schoolSettings' })
    ])
})
